import { Music2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { SCOPE_OPEN_EVENT } from "./MigrationConfirmationModal";

export default function ScopePromptCard() {
  const { user } = useAuth();
  if (!user?.profile_migration?.needs_prompt) return null;
  return (
    <section className="card-base p-5 flex items-start gap-3" data-testid="scope-prompt-card">
      <div className="w-10 h-10 rounded-xl bg-sage-100 text-sage-600 grid place-items-center shrink-0"><Music2 size={18} /></div>
      <div className="flex-1">
        <h2 className="font-heading font-semibold">Confirm your musical scope</h2>
        <p className="text-sm text-ink-600">Choose your main instrument so colleagues and bookers can find you.</p>
      </div>
      <button className="btn-primary text-sm" onClick={() => window.dispatchEvent(new Event(SCOPE_OPEN_EVENT))} data-testid="scope-prompt-open">
        Confirm now
      </button>
    </section>
  );
}
